import { useMemo } from 'react';
import type { AttachmentsResponse } from '@shared/api/rest/messages';
import { Button, Icon, Text } from '@shared/widgets';
import FileIcon from '@assets/icons/file.svg';
import CloseIcon from '@assets/icons/close.svg';
import DownloadIcon from '@assets/icons/download.svg';

export interface IMessageFileProps {
  attachment: AttachmentsResponse;
  onRemove?: () => void;
  downloadShow?: boolean;
  download?: () => void;
}

export const MessageFile = (props: IMessageFileProps) => {
  const fileSizeKb = useMemo(() => {
    if (props.attachment.fileSizeBytes) return Math.round(props.attachment.fileSizeBytes / 1024);
    return;
  }, [props.attachment]);

  if (!props.attachment) return null;
  return (
    <div className='max-w-[293px]'>
      <div className='w-full max-w-full h-10 m-0 pl-3 rounded-sm border-b border-b-light dark:border-b-primary bg-ice hover:bg-white dark:bg-soft-black inline-flex gap-2 items-center justify-between relative text-eerie-black dark:text-ice'>
        <div className='w-5 h-5 flex-none'>
          <FileIcon />
        </div>
        <Text className='min-w-0 max-w-[160px] flex-[inherit] overflow-hidden text-ellipsis whitespace-nowrap' weight='light' size='sm'>
          {props.attachment.filename}
        </Text>
        {typeof fileSizeKb === 'number' && (
          <Text className='flex-none opacity-60 whitespace-nowrap relative top-[1px]' size='xs'>
            {fileSizeKb}kb
          </Text>
        )}
        {props.onRemove && (
          <Button className='!px-0 !pr-3' onClick={props.onRemove}>
            <Icon icon={<CloseIcon width='10' height='10' />} />
          </Button>
        )}
        {!props.downloadShow && (
          <Button
            color='primary'
            className='w-11 h-10 !p-0 rounded-r-[2px] rounded-l-[0] flex items-center justify-center text-center text-xl mr-[-1px] absolute top-[-1px] right-[-1px]'
            onClick={props.download}
          >
            <Icon icon={<DownloadIcon />} color='inherit' />
          </Button>
        )}
      </div>
    </div>
  );
};
